import React, { createContext, useState, useEffect } from 'react';
import { fetchAllNotification, updatedNotification } from '../http/user.service';
import { useSelector } from 'react-redux';

export const NotificationContext = createContext();

const NotificationContextProvider = ({ children }) => {
  const token = localStorage.getItem("token");

  const [notification, setNotification] = useState([]);
  const currentUser = useSelector((data) => data.auth.currentUser);

  // useEffect(() => {
  //   console.log("inside the useEffect");
    
  //   fetchNotifications();
  // }, []);

  useEffect(() => {
    if (currentUser?._id) {
      fetchNotifications();
    }
  }, [currentUser]);

  const fetchNotifications = async () => {
    console.log("fetch Notification");
    
    try {
      const response = await fetchAllNotification(currentUser._id); 
      setNotification(response.results.userNotification);
    } catch (error) {
      console.error(error);
    }
  };

  const markAsRead = async (data) => {
    try {
        const updateAction = await updatedNotification(data);
     fetchNotifications();
    } catch (error) {
      console.error(error);
    }
  };


  return (
<NotificationContext.Provider value={{ notification, markAsRead}}>
      {children}
</NotificationContext.Provider>
  );
};
export default NotificationContextProvider;